import { UserViewModel } from '@api/index';
import { URL_DATE_FORMAT, formatISOToDate } from '@utils/dateUtil';

export const setInsiderUserInfo = (user: UserViewModel) => {
  const { id, gender, birthDate, firstName, lastName, userName, phone } = user;

  window.insider_object = window.insider_object || {};

  window.insider_object.user = {
    uuid: String(id),
    gender: gender,
    name: firstName,
    surname: lastName,
    username: userName,
    email: userName,
    email_optin: true,
    phone_number: phone,
    ...(birthDate
      ? { birthday: formatISOToDate(birthDate, URL_DATE_FORMAT) }
      : {}),
  };
};

export const clearInsiderUserInfo = () => delete window?.insider_object?.user;
